import React from 'react';

const Header = () => (
  <header className='w-full change_h bg-blue-900 flex items-center'>
    <div className='change_text ml-5 text-white font-bold'>일일 조업현황</div>
  </header>
);

export default Header;
